<mat-sidenav-container
  class="incident-sidenav-container"
  (backdropClick)="onClose()"
>
  <mat-sidenav
    #incidentSidenav
    mode="over"
    class="incident-sidenav"
    position="end"
  >
    <div class="incident-sidenav-buttons">
      <app-button
        (clicked)="onSubmit()"
        class="incident-create-button"
        color="blue"
        type="filled"
        [labelPath]="'misc.createNew'"
        iconRight="plus"
        [disabled]="submit"
        [loading]="submit"
      ></app-button>
      <app-button
        (clicked)="onClose()"
        class="incident-cancel-button"
        [labelPath]="'misc.cancel'"
      ></app-button>
    </div>
    <div class="incident-sidenav-sections">
      <mat-accordion multi>
        <mat-expansion-panel class="incident-sidenav-section" expanded>
          <mat-expansion-panel-header>
            <mat-panel-title> Information </mat-panel-title>
          </mat-expansion-panel-header>

          @for (input of informationInputs; track input.property) {
            <div
              [class]="{
                'incident-sidenav-section-item': true,
                'hidden-item': input.hidden
              }"
            >
              <div
                [class]="{ 'section-item-label': true, error: !input.valid }"
              >
                {{ input.title }}
                @if (input.mandatory) {
                  <span class="mandatory">*</span>
                }
              </div>
              @if (input.input) {
                <input
                  class="section-item-input"
                  [type]="input.type"
                  [placeholder]="'Enter a ' + input.title"
                  [(ngModel)]="incidentCreation[input.property]"
                  (ngModelChange)="setIsValid($event, input)"
                />
              }
              @if (input.selector) {
                <div
                  class="section-item-selector"
                  [matMenuTriggerFor]="ItemMenu"
                  (menuOpened)="changeArrow(input)"
                  (menuClosed)="changeArrow(input)"
                >
                  <p>{{ incidentCreation[input.property] }}</p>
                  <mat-icon>{{
                    input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</mat-icon>
                  <mat-menu class="selector-menu" #ItemMenu="matMenu">
                    <div class="selector-menu-holder">
                      @for (
                        choice of input.choices;
                        track $index;
                        let isFirst = $first
                      ) {
                        <div class="selector-menu-choice">
                          <div
                            class="selector-choice-button"
                            (click)="selectItem(choice, input)"
                          >
                            {{ choice }}
                          </div>
                        </div>
                      }
                    </div>
                  </mat-menu>
                </div>
              }
              @if (input.search_selector) {
                <div
                  class="section-item-selector"
                  [matMenuTriggerFor]="ItemMenu"
                  (menuOpened)="changeArrow(input)"
                  (menuClosed)="changeArrow(input)"
                >
                  <div class="section-item-selector">
                    <input
                      class="search_selector_input"
                      [type]="text"
                      [placeholder]="input.title | translate"
                      [ngModel]="
                        !pipeData
                          ? input.filter
                          : (input.filter | objectTransform)
                      "
                      (ngModelChange)="input.filter = $event"
                      (input)="onFilterChange(input)"
                    />
                  </div>
                  <mat-icon>
                    {{
                      input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </mat-icon>
                  <mat-menu class="selector-menu" #ItemMenu="matMenu">
                    <div class="selector-menu-holder">
                      @for (
                        choice of input.filteredOptions;
                        track $index;
                        let isFirst = $first
                      ) {
                        <div class="selector-menu-choice">
                          @if (input.search_selector) {
                            <div
                              class="selector-choice-button"
                              (click)="selectItem(choice, input, filter)"
                            >
                              @if (input.property === "currentSite") {
                                <span>{{ choice | objectTransform }}</span>
                              }
                              @if (input.property !== "currentSite") {
                                <span>{{ choice }}</span>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-menu>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
        <mat-expansion-panel class="incident-sidenav-section" expanded>
          <mat-expansion-panel-header>
            <mat-panel-title> Activity </mat-panel-title>
          </mat-expansion-panel-header>

          @for (input of activityInputs; track input.property) {
            <div
              [class]="{
                'incident-sidenav-section-item': true,
                'hidden-item': input.hidden
              }"
            >
              <div
                [class]="{ 'section-item-label': true, error: !input.valid }"
              >
                {{ input.title }}
                @if (input.mandatory) {
                  <span class="mandatory">*</span>
                }
              </div>
              @if (input.input) {
                <input
                  class="section-search-item-input"
                  type="text"
                  [placeholder]="'Enter a ' + input.title"
                  [(ngModel)]="incidentCreation[input.property]"
                />
              }
              @if (input.selector) {
                <div
                  class="section-item-selector"
                  [matMenuTriggerFor]="ItemMenu"
                  (menuOpened)="changeArrow(input)"
                  (menuClosed)="changeArrow(input)"
                >
                  <p>{{ incidentCreation[input.property] }}</p>
                  <mat-icon>{{
                    input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</mat-icon>
                  <mat-menu class="selector-menu" #ItemMenu="matMenu">
                    <div class="selector-menu-holder">
                      @for (
                        choice of input.choices;
                        track $index;
                        let isFirst = $first
                      ) {
                        <div class="selector-menu-choice">
                          <div
                            class="selector-choice-button"
                            (click)="selectItem(choice, input)"
                          >
                            {{ choice }}
                          </div>
                        </div>
                      }
                    </div>
                  </mat-menu>
                </div>
              }
              @if (input.search_selector) {
                <div
                  class="section-item-selector"
                  [matMenuTriggerFor]="ItemMenu"
                  (menuOpened)="changeArrow(input)"
                  (menuClosed)="changeArrow(input)"
                >
                  <div class="section-item-selector">
                    <input
                      class="search_selector_input"
                      [type]="text"
                      [placeholder]="input.title | translate"
                      [(ngModel)]="input.filter"
                      (input)="onFilterChange(input)"
                    />
                  </div>
                  <mat-icon>
                    {{
                      input.isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </mat-icon>
                  <mat-menu class="selector-menu" #ItemMenu="matMenu">
                    <div class="selector-menu-holder">
                      @for (
                        choice of input.filteredOptions;
                        track $index;
                        let isFirst = $first
                      ) {
                        <div class="selector-menu-choice">
                          @if (input.search_selector) {
                            <div
                              class="selector-choice-button"
                              (click)="selectItem(choice, input, filter)"
                            >
                              {{ choice }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-menu>
                </div>
              }
            </div>
          }
        </mat-expansion-panel>
        <mat-expansion-panel class="incident-sidenav-section" expanded>
          <mat-expansion-panel-header>
            <mat-panel-title> Comment </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="commentary-container">
            <textarea
              class="commentary-item-textarea"
              placeholder="Add comment"
              [(ngModel)]="commentFromSidenav"
            ></textarea>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
